// extracted by mini-css-extract-plugin
export var st0 = "vlasy-module--st0--3Lxpg";
export var svgElem1 = "vlasy-module--svg-elem-1--3xCRf";
export var active = "vlasy-module--active--3qZLu";
export var svgElem2 = "vlasy-module--svg-elem-2--2BCn1";
export var svgElem3 = "vlasy-module--svg-elem-3--35HBO";
export var svgElem4 = "vlasy-module--svg-elem-4--1JIeW";
export var svgElem5 = "vlasy-module--svg-elem-5--1aQKh";
export var svgElem6 = "vlasy-module--svg-elem-6--UAM_f";
export var svgElem7 = "vlasy-module--svg-elem-7--3ezDg";